import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import moment from "moment"
import React from "react"
import { Dimensions, useWindowDimensions, View } from "react-native"
import { connect } from "react-redux"
import live from "../../../../assets/icons/generic/live.png"
import { IconImageM } from "../../../common/components/icons/IconsM"
import PermissionBanner from "../../../common/livekit/components/PermissionBanner"
import { apiIdle, apiRequest } from "../../../data/redux/actions/api"
import { findClosestNextOccurrence } from "../../account/onboarding/LiveRoomCard"

const ConnectionHeader = (props) => {
    const liveSession = props.currentLiveSession

    const closestNextOccurrence = findClosestNextOccurrence([liveSession])

    const liveMoment = closestNextOccurrence?.date
        ? moment(closestNextOccurrence?.date)
        : null


    if (!props.isLiveModeEnabled) {
        return null
    }

    return (
        <View
            style={{
                alignItems: "center",
                alignSelf: "center",
                justifyContent: "center",
                flexDirection: "row",
                gap: 40,
                position: "absolute",
                top: 25,
            }}
        >
            <View
                style={{
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "baseline",
                        justifyContent: "center",
                    }}
                >
                    <TextM
                        fontSize={12}
                        fontWeight={"ExtraBold"}
                        color={theme.colors.white}
                        style={{
                            marginRight: 4,
                        }}
                    >
                        LIVE
                    </TextM>
                    <TextM
                        fontSize={12}
                        fontWeight={"SemiBold"}
                        color={theme.colors.white}
                    >
                        {liveSession?.live_room?.name}
                    </TextM>
                </View>
                <TextM
                    fontSize={10}
                    fontWeight={"Light"}
                    ellipsizeMode={"tail"}
                    color={theme.colors.white}
                    style={{
                    }}
                >
                    {moment(liveMoment)?.format("ddd D MMM HH:mm")}
                </TextM>
            </View>
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        currentLiveSession: state.data.currentUser?.object?.live_sessions?.find(
            (x) => x?.id === state.liveMode?.liveSessionId
        ),
        isLiveModeEnabled: state.liveMode?.isLiveModeEnabled,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(mapStateToProps, mapDispatchToProps)(ConnectionHeader)